/* Blulash page behaviour: bundle picker, gallery, sliders, timeline, popup. No dependencies. */
(function () {
  "use strict";

  var L = window.Blulash || {};
  var $ = function (s, c) {
    return (c || document).querySelector(s);
  };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var money = function (c) {
    return L.formatMoney ? L.formatMoney(c) : "$" + (c / 100).toFixed(2);
  };
  var store = {
    get: function (k) {
      try {
        return localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set: function (k, v) {
      try {
        localStorage.setItem(k, v);
      } catch (e) {}
    },
  };

  /* ---------------- bundle picker ---------------- */
  function initBuy(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = "1";
    var ups = $("[data-upsell]", form);
    var btn = $("[data-lm-atc]", form);
    var err = $("[data-lm-err]", form);

    function current() {
      return $(".lm-offer input[type=radio]:checked", form);
    }

    function update() {
      var r = current();
      $$(".lm-offer", form).forEach(function (o) {
        o.classList.toggle("is-on", !!r && o.contains(r));
      });
      var lab = r ? r.closest(".lm-offer") : null;
      var price = lab ? +lab.dataset.price : 0;
      var cmp = lab ? +lab.dataset.compare : 0;
      var upl = ups ? ups.closest(".lm-ups") : null;
      if (upl) {
        upl.classList.toggle("is-on", ups.checked);
        if (ups.checked) {
          price += +upl.dataset.price;
          cmp += +upl.dataset.compare;
        }
      }
      var t = $("[data-lm-total]", form),
        s = $("[data-lm-compare]", form);
      if (t) t.textContent = money(price);
      if (s) s.textContent = cmp > price ? money(cmp) : "";
      form.dispatchEvent(
        new CustomEvent("blulash:offer", {
          bubbles: true,
          detail: { title: lab ? lab.dataset.title : "", price: price },
        }),
      );
    }

    form.addEventListener("change", update);

    form.addEventListener("click", function (e) {
      var sw = e.target.closest(".lm-swb");
      if (!sw) return;
      e.preventDefault();
      e.stopPropagation();
      var g = sw.closest(".lm-sws");
      $$(".lm-swb", g).forEach(function (b) {
        b.setAttribute("aria-pressed", b === sw ? "true" : "false");
      });
      var n = $(".lm-swn", g);
      if (n) n.textContent = sw.dataset.shade;
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var r = current();
      if (!r) return;
      var lab = r.closest(".lm-offer");
      // Each tube picks a color variant; same colors are merged into one line.
      var counts = {},
        order = [];
      $$(".lm-sws", lab).forEach(function (g) {
        var on =
          $(".lm-swb[aria-pressed=true]", g) || $(".lm-swb:not([disabled])", g);
        if (!on) return;
        var id = on.dataset.variant;
        if (!counts[id]) {
          counts[id] = 0;
          order.push(id);
        }
        counts[id] += 1;
      });
      if (!order.length && lab.dataset.variant) {
        order.push(lab.dataset.variant);
        counts[lab.dataset.variant] = +r.value || 1;
      }
      if (!order.length) {
        if (err) err.textContent = "Please pick a shade.";
        return;
      }
      var items = order.map(function (id) {
        return { id: +id, quantity: counts[id] };
      });
      if (ups && ups.checked) items.push({ id: +ups.value, quantity: 1 });
      if (err) err.textContent = "";
      btn.classList.add("is-loading");
      btn.disabled = true;
      (L.addItems
        ? L.addItems(items)
        : Promise.reject(new Error("Cart unavailable"))
      )
        .then(function () {
          if (L.afterAdd) L.afterAdd();
        })
        .catch(function (x) {
          if (err)
            err.textContent =
              (x && (x.description || x.message)) ||
              "Something went wrong. Please try again.";
        })
        .then(function () {
          btn.classList.remove("is-loading");
          btn.disabled = false;
        });
    });

    update();
  }

  /* ---------------- sticky add to bag ---------------- */
  function initSticky(bar) {
    var target = document.getElementById(bar.dataset.lmSticky);
    if (!target) return;
    var form = $("form", target);
    var line = $("[data-lm-sticky-line]", bar);
    function sync(d) {
      if (line && d) line.textContent = d.title + " · " + money(d.price);
    }
    if (form) {
      form.addEventListener("blulash:offer", function (e) {
        sync(e.detail);
      });
      var r = $(".lm-offer.is-on", form);
      if (r) sync({ title: r.dataset.title || "", price: +r.dataset.price });
    }
    $("[data-lm-sticky-btn]", bar).addEventListener("click", function () {
      // Bundle app form: bring the app's bundle picker into view so the shopper chooses there.
      if (form && form.hasAttribute("data-lm-appform")) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (form && form.requestSubmit) form.requestSubmit();
      else target.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    if (!("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        bar.classList.toggle("is-on", !en.isIntersecting && below);
      });
    }).observe(target);
  }

  /* ---------------- gallery ---------------- */
  function initGallery(g) {
    var slides = $$(".lm-gal__slide", g),
      thumbs = $$("[data-gal-to]", g),
      i = 0;
    if (slides.length < 2) {
      $$(".lm-gal__arrow", g).forEach(function (a) {
        a.hidden = true;
      });
    }
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle("is-on", k === i);
      });
      thumbs.forEach(function (t, k) {
        t.setAttribute("aria-current", k === i ? "true" : "false");
      });
      var th = thumbs[i];
      if (th && th.parentNode) {
        var strip = th.parentNode;
        strip.scrollTo({ left: th.offsetLeft - strip.offsetLeft - (strip.clientWidth - th.clientWidth) / 2, behavior: "smooth" });
      }
    }
    g.addEventListener("click", function (e) {
      if (e.target.closest("[data-gal-prev]")) go(i - 1);
      else if (e.target.closest("[data-gal-next]")) go(i + 1);
      else {
        var t = e.target.closest("[data-gal-to]");
        if (t) go(+t.dataset.galTo);
      }
    });
    var x0 = null,
      stage = $(".lm-gal__stage", g);
    stage.addEventListener(
      "touchstart",
      function (e) {
        x0 = e.touches[0].clientX;
      },
      { passive: true },
    );
    stage.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------------- before / after slider ---------------- */
  function initCompare(c) {
    var input = $("input", c),
      after = $(".lm-compare__after", c),
      bar = $(".lm-compare__bar", c);
    function set() {
      var v = input.value + "%";
      after.style.clipPath = "inset(0 0 0 " + v + ")";
      bar.style.left = v;
    }
    input.addEventListener("input", set);
    set();
  }

  /* ---------------- rail progress ---------------- */
  function initRail(rail) {
    var bar = rail.parentElement && $(".lm-progress i", rail.parentElement);
    if (!bar) return;
    function set() {
      var max = rail.scrollWidth - rail.clientWidth;
      var vis =
        Math.max(Math.min(rail.clientWidth / rail.scrollWidth, 1), 0.15) * 100;
      bar.style.width = vis + "%";
      bar.style.left =
        (max > 0 ? (rail.scrollLeft / max) * (100 - vis) : 0) + "%";
    }
    rail.addEventListener("scroll", set, { passive: true });
    window.addEventListener("resize", set);
    set();
  }

  /* ---------------- timeline ---------------- */
  function initTimeline(tl) {
    var nodes = $$(".lm-tnode", tl),
      fill = $(".lm-track__fill", tl);
    function go(i) {
      nodes.forEach(function (n, k) {
        n.setAttribute("aria-pressed", k === i ? "true" : "false");
        n.classList.toggle("is-done", k < i);
        var p = document.getElementById(n.getAttribute("aria-controls"));
        if (p) p.hidden = k !== i;
      });
      if (fill && nodes.length > 1)
        fill.style.width =
          "calc(" +
          i / (nodes.length - 1) +
          " * (100% - 100% / " +
          nodes.length +
          "))";
    }
    nodes.forEach(function (n, k) {
      n.addEventListener("click", function () {
        go(k);
      });
    });
    go(0);
  }

  /* ---------------- stat counters ---------------- */
  function initStats(root) {
    var els = $$("[data-count]", root);
    if (!els.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target,
            to = +el.dataset.count,
            t0 = null;
          function step(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 1200, 1);
            el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + "%";
            if (p < 1) requestAnimationFrame(step);
          }
          el.textContent = "0%";
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 },
    );
    els.forEach(function (e) {
      io.observe(e);
    });
  }

  /* ---------------- popup ---------------- */
  function initPopup(pop) {
    var KEY = "blulash-pop";
    var code = pop.dataset.code;
    var steps = $$("[data-step]", pop);
    var opener = null;
    function show(n) {
      steps.forEach(function (s) {
        s.hidden = s.dataset.step !== String(n);
      });
    }
    function open() {
      opener = document.activeElement;
      show(1);
      pop.hidden = false;
      var b = $(".lm-env", pop);
      if (b) b.focus();
    }
    function close() {
      pop.hidden = true;
      store.set(KEY, "1");
      if (opener && opener.focus) opener.focus();
    }
    $$("[data-pop-close]", pop).forEach(function (b) {
      b.addEventListener("click", close);
    });
    pop.addEventListener("click", function (e) {
      if (e.target === pop) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !pop.hidden) close();
    });

    var envWrap = $(".lm-envs", pop);
    var prizes = (envWrap.dataset.prizes || "15%,10%,Gift").split(",");
    $$(".lm-env", envWrap).forEach(function (b, idx, all) {
      b.addEventListener("click", function () {
        var rest = prizes.slice(1);
        all.forEach(function (e, k) {
          e.disabled = true;
          if (k === idx) {
            e.classList.add("is-open");
            e.textContent = prizes[0];
          } else {
            e.classList.add("is-dim");
            e.textContent = rest.shift() || "";
          }
        });
        setTimeout(function () {
          show(2);
          var i = $("input[type=email]", pop);
          if (i) i.focus();
        }, 900);
      });
    });

    var form = $("[data-pop-form]", pop) || $("form", pop);
    if (form)
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch(form.action, {
          method: "POST",
          body: fd,
          credentials: "same-origin",
        }).catch(function () {});
        store.set(KEY, "1");
        show(3);
      });

    var copy = $("[data-pop-copy]", pop);
    if (copy)
      copy.addEventListener("click", function () {
        var done = function () {
          copy.textContent = "Copied";
        };
        if (navigator.clipboard)
          navigator.clipboard.writeText(code).then(done, function () {});
        else {
          var r = document.createRange(),
            s = getSelection();
          r.selectNodeContents($("[data-pop-code]", pop));
          s.removeAllRanges();
          s.addRange(r);
        }
      });

    var shop = $("[data-pop-shop]", pop);
    if (shop && code) {
      var dest = shop.getAttribute("href") || "/";
      shop.setAttribute(
        "href",
        "/discount/" +
          encodeURIComponent(code) +
          "?redirect=" +
          encodeURIComponent(dest),
      );
    }

    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode) {
      document.addEventListener("shopify:section:select", function (e) {
        if (pop.closest("#shopify-section-" + e.detail.sectionId)) open();
      });
      document.addEventListener("shopify:section:deselect", function (e) {
        if (pop.closest("#shopify-section-" + e.detail.sectionId))
          pop.hidden = true;
      });
      return;
    }
    if (store.get(KEY)) return;
    setTimeout(
      function () {
        if (!store.get(KEY)) open();
      },
      (+pop.dataset.delay || 8) * 1000,
    );
  }

  /* ---------------- smooth in-page links ---------------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute("href").length < 2) return;
    var t = document.getElementById(a.getAttribute("href").slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  function init(root) {
    root = root || document;
    // One broken block must not stop the others from starting.
    [
      ["[data-lm-buy]", initBuy],
      ["[data-lm-sticky]", initSticky],
      ["[data-lm-gal]", initGallery],
      ["[data-lm-slider]", initCompare],
      ["[data-lm-rail]", initRail],
      ["[data-lm-tl]", initTimeline],
      [".lm-stats", initStats],
      ["#LmPopup", initPopup],
    ].forEach(function (pair) {
      $$(pair[0], root).forEach(function (el) {
        try {
          pair[1](el);
        } catch (e) {
          if (window.console) console.error("[Blulash]", pair[0], e);
        }
      });
    });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  else init();
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });


  /* ---------- Kaching: per-offer gift list built from the deal's progressive-gift settings ---------- */
  (function () {
    var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="#2546d6" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
    function fmt(c) { var v = c / 100; return "$" + (v % 1 ? v.toFixed(2) : String(v)); }
    function esc(t) { var d = document.createElement("div"); d.textContent = t; return d.innerHTML; }
    function giftsFor(block) {
      if (block._lmGifts) return block._lmGifts;
      var deal, prods;
      try { deal = JSON.parse(block.getAttribute("deal-block") || "{}"); prods = JSON.parse(block.getAttribute("other-products") || "[]"); } catch (e) { return null; }
      if (!deal.progressiveGiftsEnabled || !deal.progressiveGifts) return null;
      var byId = {}; prods.forEach(function (p) { byId["gid://shopify/Product/" + p.id] = p; });
      var list = (deal.progressiveGifts.gifts || []).map(function (g) {
        if (g.giftType === "shipping") return { at: g.unlockAtBar, only: g.unlockAtBarOnly, title: g.title || "Free shipping", price: 0, ship: true };
        var p = byId[g.productGID]; if (!p) return null;
        var v = p.variants && p.variants[0];
        return { at: g.unlockAtBar, only: g.unlockAtBarOnly, title: p.title.replace(/\s*\((PDF|\$\d+)\)\s*$/, ""), price: v ? v.price * (g.quantity || 1) : 0, img: p.image };
      }).filter(Boolean);
      block._lmBars = (deal.dealBars || []).map(function (b) { return b.id; });
      block._lmGifts = list; return list;
    }
    function paint(block) {
      var gifts = giftsFor(block); if (!gifts || !gifts.length) return;
      block.querySelectorAll(".kaching-bundles__bar[data-deal-bar-id]").forEach(function (bar) {
        var n = block._lmBars.indexOf(bar.getAttribute("data-deal-bar-id")) + 1;
        if (n < 1) return;
        var mine = gifts.filter(function (g) { return g.only ? g.at === n : g.at <= n; });
        var left = bar.querySelector(".kaching-bundles__bar-content-left");
        var wrap = bar.querySelector(".kaching-bundles__bar-wrapper");
        if (!left || !wrap) return;
        var cnt = left.querySelector(".lm-bar-giftcount");
        if (mine.length && !cnt) {
          cnt = document.createElement("div"); cnt.className = "lm-bar-giftcount";
          cnt.textContent = "+ " + mine.length + " free gift" + (mine.length > 1 ? "s" : ""); left.appendChild(cnt);
        }
        if (mine.length && !wrap.querySelector(".lm-bar-gifts")) {
          var total = mine.reduce(function (a, g) { return a + g.price; }, 0);
          var h = '<div class="lm-bar-gifts__head"><b>+ Free gifts with your order</b>' + (total ? '<span>' + fmt(total) + ' value</span>' : "") + "</div>";
          mine.forEach(function (g) {
            h += '<div class="lm-bar-gifts__row"><span class="lm-bar-gifts__img">' + (g.ship ? TRUCK : '<img src="' + g.img + '" alt="" loading="lazy">') +
              '</span><span class="lm-bar-gifts__t"><b><em>FREE</em> ' + esc(g.title) + "</b><small>" + (g.ship ? "On this order" : "Worth " + fmt(g.price)) + "</small></span></div>";
          });
          var box = document.createElement("div"); box.className = "lm-bar-gifts"; box.innerHTML = h; wrap.appendChild(box);
        }
      });
    }
    function scan() { document.querySelectorAll("kaching-bundles-block").forEach(paint); }
    var queued = false;
    new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; scan(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState !== "loading") scan(); else document.addEventListener("DOMContentLoaded", scan);
  })();
})();
